interface RuntimeConfig {
  VITE_BASE_API_PATH?: string;
  VITE_BASE_PATH?: string;
  VITE_AUTH_AUTHORITY?: string;
  VITE_AUTH_CLIENT_ID?: string;
  VITE_AUTH_REDIRECT_URI?: string;
  [key: string]: string | undefined;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

export const getEnvConfig = (): RuntimeConfig => {
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__;
  }
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env as RuntimeConfig;
  }
  return {};
};

export const getBasePath = (): string | undefined => {
  return getEnvConfig().VITE_BASE_PATH;
};

export const getAuthAuthority = (): string | undefined => {
  return getEnvConfig().VITE_AUTH_AUTHORITY;
};

export const getAuthClientId = (): string | undefined => {
  return getEnvConfig().VITE_AUTH_CLIENT_ID;
};

export const getAuthRedirectUri = (): string | undefined => {
  return getEnvConfig().VITE_AUTH_REDIRECT_URI;
};
